var axios = require('axios');

var projectNo = "SFT";

export default {

/* TIANYAURL: "http://rjttj.softtone.cn", //登录，用户管理用这个

	PERSONALURL: "http://api1.softtone.cn",

	USERURL: "http://share.jqweike.com/", //有关用户信息的api
  */

/* 	TIANYAURL:"http://122.225.6.194:8099",//登录，用户管理用这个

	PERSONALURL: "http://122.225.6.194:8083",

  USERURL: "http://122.225.6.194:8091/", //有关用户信息的api */

 	TIANYAURL:apiConfig.TIANYAURL,//登录，用户管理用这个

	PERSONALURL: apiConfig.APIURL,

	USERURL: apiConfig.USERURL, //有关用户信息的api

	URL:apiConfig.WEBURL,

	PROJECTNO: "SFT",


	//用于新注册的用户选择机构
	//机构列表
	getOrgList:function(keyword,pagesize){

		return axios.post(this.TIANYAURL + "/admin/agency/get?isCallCommon=true&keyword=" + keyword + "&pageindex=1&pagesize=" + pagesize, {

		})

	},
	//设置机构
	selectOrg:function(accessToken,id){

		return axios.post(this.USERURL + "/v1/frontend/user/update-user-agency", {
				"token": accessToken,
				"id": id,
				"isTem": true
		});

	},

	//更新数据
	UpdateUserData: function(userId, token) {
		return axios.post(this.TIANYAURL + "/user/thirdParty/get-and-save", {
			userID: userId,
			username: "",
			headerurl: "",
			token: token,
			projectCode: projectNo
		});
	},
	//获取个人信息
	GetUserInf: function(token) {
		return axios.get(this.TIANYAURL + "/account/info", {
			headers: {
				"Authorization": token
			}
		})
	},

	//游客登录
	TouristLogin: function() {
		return axios.post(this.TIANYAURL + "/user/guest?projectNo=" + projectNo, {

		})
	},
  //获取登出地址
  GetLoginOut: function(orgID) {
  	return axios.get(this.PERSONALURL + "/loginout/get", {
  		params: {
  			"orgID": orgID,
        "Code":"sft_wx"
  		}
  	})
  },
	//获取积分
	GetScore: function() {
		var token = localStorage.getItem("accessToken");
		return axios.get(this.TIANYAURL + "/vip/score/getScoreGrade", {
			params: {
				projectNo: projectNo
			},
			headers: {
				"Authorization": token
			}
		})
	},

	//积分加入
	SetScore: function(type) {
		var token = localStorage.getItem("accessToken");
		var url = this.TIANYAURL + "/vip/user/score/set?type=" + type + "&projectNo=" + projectNo
		return axios({
			method: "post",
			url: url,
			headers: {
				"Authorization": token,
				"Content-type": "application/x-www-form-urlencoded"
			}
		})
	},
	//获取积分流水列表
	GetScoreList: function(type) {
		var token = localStorage.getItem("accessToken");
		return axios.get(this.TIANYAURL + "/vip/score/list?projectNo=" + projectNo + "&type=" + type +
			"&pageindex=1&pagesize=999", {
				headers: {
					"Authorization": token
				}
			})
	},
	//学习记录
	StudyRecord: function(year, token) {
		return axios.get(this.TIANYAURL + "/log/getalllog/?projectNo=" + projectNo + "&pageindex=1&pagesize=11111", {
			params: {
				year: year
			},
			headers: {
				"Authorization": token
			}
		})
	},

	//获取我的课程
	UserVideo: function(isHistory) {
		var userID = localStorage.getItem("userId");
		return axios.get(this.PERSONALURL + "/uservideo/get/list", {
			params: {
				isHistory: isHistory,
				userID: userID,
				pageindex: "1",
				pagesize: "200"
			}
		})
	},
	//删除我的课程
	DeleteCourse: function(progressID) {
		var url = this.PERSONALURL + "/uservideo/delete?progressID=" + progressID + "&isDelete=true";
		return axios({
			method: "post",
			url: url
		})
	},
	//获取对应收藏类型的目录
	CollectCatalog: function(favTypeno) {

		var token = localStorage.getItem("accessToken");
		return axios.get(this.TIANYAURL + "/favorite/category/getAll/{favTypeno}?favTypeno=" + favTypeno, {
			headers: {
				"Authorization": token
			}
		});

	},

	//根据收藏类型获取对应的收藏数据
	CollectContent: function(favTypeno) {

		var token = localStorage.getItem("accessToken");
		return axios.get(this.TIANYAURL + "/favorite/item/{typeno}?typeno=" + favTypeno + '&pageindex=1&pagesize=99999', {
			headers: {
				"Authorization": token
			}
		});

	},
	//取消收藏
	DeleteConllect: function(id) {
		var token = localStorage.getItem("accessToken");
		var url = this.TIANYAURL + "/favorite/item/delete?id=" + id;
		return axios({
			method: "post",
			url: url,
			headers: {
				"Authorization": token
			}
		})
	},
	//判断是否收藏
	IsConllect: function(contextID) {
		var token = localStorage.getItem("accessToken");
		var url = this.TIANYAURL + "/favorite/item/" + contextID;
		return axios({
			method: "post",
			url: url,
			headers: {
				"Authorization": token
			}
		})
	},
	//添加收藏
	addConllect: function(data) {
		var token = localStorage.getItem("accessToken");
		var url = this.TIANYAURL + "/favorite/item/add";
		return axios.post(this.TIANYAURL + "/favorite/item/add", {
			FavTypeNo: data.FavTypeNo,
			ContextID: data.ContextID,
			CategoryID: data.CategoryID,
			ProjectNo: projectNo
		}, {
			headers: {
				"Authorization": token
			}
		});

	},
	//添加收藏分组
	AddCollectGroupList: function(type, Name) {
		var token = localStorage.getItem("accessToken");
		var url = this.TIANYAURL + "/favorite/category/add";
		return axios({
			method: "post",
			url: url,
			data: {
				"Name": Name,
				"ParentID": "",
				"FavTypeNo": type,
				"ProjectNo": projectNo,
				"Level": 0
			},
			headers: {
				"Authorization": token,
			}
		})
	},
	//根据课程id获取对应的课程
	GetCourse: function(IDlist) {
		return axios({
			method: "post",
			url: this.PERSONALURL + "/Course/multiple/get",
			data: IDlist
		})
	},
	//根据视频ID获取对应的视频
	GetRescourse: function(IDlist) {
		return axios({
			method: "post",
			url: this.PERSONALURL + "/Rescourse/get/multiple",
			data: IDlist
		})
	},
	//根据视频id获取问题详情
	GetVideoReply: function(videoID) {
		var token = localStorage.getItem("accessToken");
		return axios.get(this.TIANYAURL + "/question/video/get?relatedid2=" + videoID + "&projectNo=" + projectNo +
			"&pageindex=1&pagesize=9999", {
				headers: {
					"Authorization": token
				}
			});
	},
	//获取我回答的问题详情
	GetJoinReply: function(videoID) {
		return axios.get(this.TIANYAURL + "/question/relatedid2/get?relatedid2=" + videoID + "&projectNo=" + projectNo +
			"&pageindex=1&pagesize=9999", {

			});
	},
	//获得登录用户添加过笔记的课程号
	GetNoteCourse: function() {
		var token = window.localStorage.getItem("accessToken");
    var userName = window.localStorage.getItem("userName");
		return axios.get(this.TIANYAURL + "/note/get/course", {
			headers: {
				"Authorization": token
			}
		});
	},
	//获得某个用户的笔记列表
	GetNoteList: function() {

		var token = window.localStorage.getItem("accessToken");

		return axios.get(this.TIANYAURL + "/note/get/list?&pageindex=1&pagesize=99999", {
			headers: {
				"Authorization": token
			}
		});

	},
	//删除某个笔记
	DeleteNote: function(id) {
		var token = localStorage.getItem("accessToken");

		var url = this.TIANYAURL + "/note/delete/" + id;
		return axios({
			method: "post",
			url: url,
			headers: {
				"Authorization": token
			}
		})

	},
	//获取我的提问
	GetMyQuestions: function() {
		var token = localStorage.getItem("accessToken");
		return axios.get(this.PERSONALURL + "/question/get?token=" + token + "&pageindex=1&pagesize=111&projsectCode=" +
			projectNo, {

			});
	},
	//获取参与的答疑
	GetJoinQuestions: function() {
		var token = localStorage.getItem("accessToken");
		return axios.get(this.TIANYAURL + "/question/my/ansget?projectNo=" + projectNo + "&pageindex=1&pagesize=999", {
			headers: {
				"Authorization": token
			}
		});
	},
	//根据问题ID获取对应的问答
	GETQuestion: function(IDlist) {
		var token = localStorage.getItem("accessToken");
		return axios({
			method: "post",
			url: this.TIANYAURL + "/question/get/list?typeno=qtn",
			data: IDlist,
			headers: {
				"Authorization": token
			}
		})
	},
	//获取我的人脉/好友组
	GetGroupList: function() {
		var token = localStorage.getItem("accessToken");
		return axios.get(this.TIANYAURL + "/friend/group/list?pageindex=1&pagesize=999&projectCode=" + projectNo + "", {
			headers: {
				"Authorization": token
			}
		});

	},
	//添加分组
	AddGroupList: function(name) {
		var token = localStorage.getItem("accessToken");
		var url = this.TIANYAURL + "/people/group/add";
		return axios({
			method: "post",
			url: url,
			data: {
				"name": name,
				"projectNo": projectNo
			},
			headers: {
				"Authorization": token,
			}
		})
	},
	//添加人脉
	AddFriend: function(userID, GroupID) {
		var token = localStorage.getItem("accessToken");
		var url = this.TIANYAURL + "/people/add";
		return axios({
			method: "post",
			url: url,
			data: {
				"targetUserId": userID,
				"projectNo": projectNo,
				"GroupID": GroupID
			},
			headers: {
				"Authorization": token,
			}
		})
	},
	//获取某个分组好友
	GetFriendList: function(groupid) {
		var token = localStorage.getItem("accessToken");
		return axios.get(this.TIANYAURL + "/friend/list?pageindex=1&pagesize=111&groupid=" + groupid + "&projectCode=" +
			projectNo, {
				headers: {
					"Authorization": token
				}
			});
	},
	//获取所有好友
	GetAllFriendList: function() {
		var token = localStorage.getItem("accessToken");
		return axios.get(this.TIANYAURL + "/friend/list?projectCode=" + projectNo, {
			headers: {
				"Authorization": token
			}
		});
	},
	//删除好友
	DeleteFriend: function(friengID) {
		var token = localStorage.getItem("accessToken");
		return axios({
			method: "post",
			url: this.TIANYAURL + "/people/delete/" + friengID,
			headers: {
				"Authorization": token
			}
		})
	},
	//查看是否是好友
	isFriends: function(userId) {
		var token = localStorage.getItem("accessToken");
		return axios({
			method: "post",
			url: this.TIANYAURL + "/people/isfriend/?userid=" + userId,
			headers: {
				"Authorization": token
			}
		})
	},
	//获取所有聊天消息
	GetMassageAll: function() {
		var token = localStorage.getItem("accessToken");
		return axios.get(this.TIANYAURL + "/people/message/all?pagesize=111&pageindex=1", {
			headers: {
				"Authorization": token
			}
		});
	},
	//获取指定用户聊天消息
	GetMassageSome: function(friengID) {
		var token = localStorage.getItem("accessToken");
		return axios.get(this.TIANYAURL + "/people/message/" + friengID, {
			headers: {
				"Authorization": token
			}
		});
	},
	//发送聊天信息
	SendMessage: function(friengID, content) {
		var token = localStorage.getItem("accessToken");
		return axios({
			method: "post",
			url: this.TIANYAURL + "/people/sendmessage",
			data: {
				acceptid: friengID,
				content: content
			},
			headers: {
				"Authorization": token
			}
		})
	},
	//数组去除重复 (利用json对象是否有属性值)
	RemoverRepetition: function outRepeat(a) {
		var hash = [],
			arr = [];
		for (var i = 0; i < a.length; i++) {
			hash[a[i]] != null;
			if (!hash[a[i]]) {
				arr.push(a[i]);
				hash[a[i]] = true;
			}
		}
		console.log(arr);
	},
	//转换时间
	TransformTime: function(t) {
		//计算小时
		var h;
		h = Math.floor(t / 3600);
		//计算分钟
		var m;
		m = Math.floor((t - h * 3600) / 60);
		//计算秒
		var s;
		s = (t - h * 3600 - m * 60) % 60;
		//将变量转换为字符串
		h += '';
		m += '';
		s += '';
		//如果只有一位数，前面增加一个0
		h = (h.length == 1) ? '0' + h : h;
		m = (m.length == 1) ? '0' + m : m;
		s = (s.length == 1) ? '0' + s : s;
		return h + ':' + m + ":" + s;
	},
	// 跳转到视频播放界面
	JumpVideo: function(url, IDCode) {
		this.$router.push({
			path: url,
			name: url,
			params: {
				IDCode: IDCode,
				level1: this.$route.params.level1,
				level2: this.$route.params.level2,
				level3: this.$route.params.level3,
			}
		})
	},
}



//////////////////
// WEBPACK FOOTER
// ./static/api/api1.js
// module id = null
// module chunks = 